export default {"src":"/_next/static/media/fishing.858b1cef.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};